export default function () {
    function build(entity) {
        if (!entity) throw Error('No supplied entity.');
        return {
            ...entity,
            stream_chapter_starts_short_time: chapterStartsShortTime(entity),
        };
    }

    const UtilityDates = useUtilityDates();

    function chapterStartsShortTime(entity) {
        if (!entity.stream_chapter_starts) return undefined;
        return UtilityDates.printDateTime(entity.stream_chapter_starts, 'shortTime');
    }

    return {build};
}
